import {adaptErrors} from "./dto/org.springframework.validation";
import {createHtmlElement} from "./lib/domFunctions";
import {escapeHTML} from "./lib/escapeHTML";
import {coalesce, toEmptyString} from "./lib/coalesce";
import Sortable from 'sortablejs/modular/sortable.core.esm.js';
import {Messages} from "./messages/Messages";

const messages = new Messages();

interface InstructionType {
	id: number
	name: string
	flags: number
	description: string
	code: number
	paramValue1: number
	paramValue2: number
	paramLabel1: string
	paramLabel2: string
}

interface FormStep {
	id: number
	itypeId?: number
	itype?: InstructionType
	param1?: string
	param2?: string
}

export class InstructionBlockEditPage {
	private readonly itypes: InstructionType[];
	private instructionsList: HTMLElement;
	private instructionsCount: number;

	constructor(setup: { itypes: InstructionType[] }) {
		this.itypes = setup.itypes || [];
		this.instructionsList = document.querySelector<HTMLUListElement>('#instructions')!!
		this.instructionsCount = 0;
	}

	displayForm(form: any, formErrors: any) {
		formErrors = adaptErrors(formErrors)

		const syncCommands = document.querySelector<HTMLUListElement>('#syncCommands')!!
		const otherCommands = document.querySelector<HTMLUListElement>('#otherCommands')!!

		const itypeMap = new Map<number, { name: string, description: string, code: number }>();
		for (const iType of this.itypes.sort((a, b) => a.name.localeCompare(b.name))) {
			const commandLower = iType.name.toLowerCase()
			const syncCommand = commandLower.includes("sync") || commandLower.includes("wait") || commandLower.includes("ожидани") || commandLower.includes("задержк");
			const commandList = syncCommand ? syncCommands : otherCommands;

			commandList.append(createHtmlElement(`li`, {class: `list-inline-item mb-2`}, `
			<span class="btn btn-secondary rounded cursor-pointer" onclick="controller.appendInstructionByType(${iType.id})" title="${escapeHTML(iType.description)}">${escapeHTML(iType.name)}</span>
			`))
			itypeMap.set(iType.id, iType);
		}

		for (const ins of form.instructions) {
			const index = this.instructionsCount++;
			ins.itype = itypeMap.get(ins.itypeId);
			this.renderInstructionRow(index, ins);
		}

		this.recalculateOrder()

		const formElement = document.getElementById('form');
		if (formElement) formElement.hidden = false;

		Sortable.create(this.instructionsList, {
			handle: ".drag-handle",
			onStart: () => {
				this.instructionsList.closest('table')?.classList.remove('table-hover')
			},
			onEnd: () => {
				this.instructionsList.closest('table')?.classList.add('table-hover')
				this.recalculateOrder()
			}
		});
	}

	private updateEmptyNotice() {
		const empty = this.instructionsList.childElementCount == 0;
		document.getElementById('emptyNotice')!.hidden = !empty;

		const tableHead = this.instructionsList.closest('table')?.querySelector('thead')
		if (tableHead) tableHead.hidden = empty;
	}

	private renderInstructionRow(index: number, data: FormStep) {
		const itype = this.itypes.find(t => t.id == data.itypeId);
		console.info(JSON.stringify(data))
		const param1 = (coalesce(itype?.flags, 0) & 1) == 1 ? `` : `
<div class="row align-items-baseline">
	<div class="col-6">
		<input type="text" class="form-control d-inline-block" name="instructions[${index}].param1" placeholder="${escapeHTML(toIntString(itype?.paramValue1))}" value="${escapeHTML(toEmptyString(data.param1))}"/>
	</div>
	<div class="col-6">${escapeHTML(itype?.paramLabel1)}</div>
</div>
`;
		const param2 = (coalesce(itype?.flags, 0) & 2) == 2 ? `` : `
<div class="row align-items-baseline">
	<div class="col-6">
		<input type="text" class="form-control d-inline-block" name="instructions[${index}].param2" placeholder="${escapeHTML(toIntString(data.itype?.paramValue2))}" value="${escapeHTML(toEmptyString(data.param2))}"/>
	</div>
	<div class="col-6">${escapeHTML(itype?.paramLabel2)}</div>
</div>
`;
		const tr = createHtmlElement(`tr`, {class: `align-baseline`}, `
		<td class="td-ins-order">
  			<button type="button" class="btn btn-danger text-capitalize me-3" onclick="controller.removeStep(this)" title="удалить шаг" data-bind="removeStep"><i class="fal fa-times"></i></button>
			<button type="button" class="btn btn-light drag-handle" title="${messages.get('process.form.stepDrag')}" data-bind="stepDrag"><i class="fal fa-sort-alt"></i></button>
			<input type="hidden" name="instructions[${index}].order" value="0">
			<input type="hidden" name="instructions[${index}].id" value="${data.id}">
			<input type="hidden" name="instructions[${index}].itypeId" value="${data.itypeId}">
			<span class="ms-4" data-bind="instructionOrder">${index + 1}:</span>
		</td>
		<td class="td-ins-name">
			<span title="${escapeHTML(data.itype?.description)}">${escapeHTML(data.itype?.name || `type#${data.itypeId}`)}</span>
		</td>
		<td class="td-ins-params">${param1}${param2}</td>		
		`);

		this.instructionsList.append(tr)
	}

	appendInstructionByType(id: number) {
		const itype = this.itypes.filter(it => it.id === id)[0];
		if (!itype) return;

		const index = this.instructionsCount++;
		this.renderInstructionRow(index, {id: 0, itypeId: itype.id, itype: itype});
		this.recalculateOrder();
	}

	private recalculateOrder() {
		let order = 0;
		const trList = Array.from(this.instructionsList.querySelectorAll(`tr`));
		for (const tr of trList) {
			tr.querySelector<HTMLInputElement>(`input[name$=".order"]`)!.value = order.toString()
			tr.querySelector<HTMLElement>(`[data-bind="instructionOrder"]`)!.textContent = `${order + 1}:`
			// tr.querySelector<HTMLButtonElement>(`[data-bind="stepDown"]`)!.disabled = order >= trList.length - 1;
			// tr.querySelector<HTMLButtonElement>(`[data-bind="stepUp"]`)!.disabled = order < 1;

			++order;
		}

		this.updateEmptyNotice()
	}

	removeStep(button: HTMLButtonElement) {
		button.closest('tr')?.remove();
		this.recalculateOrder();
	}

	stepOrderMinus(button: HTMLButtonElement) {
		const tr = button.closest('tr')!!
		const previous = tr.previousElementSibling
		if (previous) {
			swapWithNext(previous).then(() => this.recalculateOrder());
		}
	}

	stepOrderPlus(button: HTMLButtonElement) {
		const tr = button.closest('tr')!!
		const next = tr.nextElementSibling
		if (next) {
			swapWithNext(tr).then(() => this.recalculateOrder());
		}
	}

}

function toIntString(n: any) {
	if (typeof n === "number") {
		return `${n}`;
	}
	return ``;
}

function swapWithNext(el: Element): Promise<boolean> {
	const next = el.nextElementSibling;
	if (!next) return Promise.reject('no next sibling');

	let rowHeight = el.clientHeight;
	let animationLength = 300;

	el.setAttribute('style', `transform: translate(0px, ${rowHeight}px); background-color:  cadetblue; transition: transform ${animationLength}ms`);
	next.setAttribute('style', `transform: translate(0px, -${rowHeight}px); background-color: aliceblue; transition: transform ${animationLength}ms`);

	return new Promise((resolve) => {
		setTimeout(function () {
			next.after(el);
			next.removeAttribute('style');
			el.removeAttribute('style');

			resolve(true);
		}, animationLength);
	})
}